module.exports = __webpack_public_path__ + "img/logo-powered-by.b393eb39.svg";